<template>
  <div class="footer">
    <div
      v-for="(item, index) in config"
      :key="index"
      class="item"
      @click="go(item)"
    >
      <img
        :src="$route.fullPath === item.path ? item.activeIcon : item.icon"
        class="icon"
      >
      <p
        class="title"
        :class="{ active: $route.fullPath === item.path }"
      >{{ item.name }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Footer",
    data() {
      return {
        config: [
          {
            name: '主页',
            icon: require('@/assets/image/footer/home.png'),
            activeIcon: require('@/assets/image/footer/home-active.png'),
            path: '/index'
          },
          {
            name: '补打',
            icon: require('@/assets/image/footer/reprint.png'),
            activeIcon: require('@/assets/image/footer/reprint-active.png'),
            path: '/print-again'
          },
          {
            name: '打印标签',
            icon: require('@/assets/image/footer/print.png'),
            activeIcon: require('@/assets/image/footer/print-active.png'),
            path: '/template'
          },
          {
            name: '我的',
            icon: require('@/assets/image/footer/my.png'),
            activeIcon: require('@/assets/image/footer/my-active.png'),
            path: '/my'
          }
        ]
      }
    },
    methods: {
      go(item) {
        const {
          path
        } = item

        this.$router.push(path)
      }
    }
  }
</script>

<style lang="less" scoped>
  .footer {
    height: 270px;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .flexgap(16px, column);
      .icon {
        width: 76px;
        height: 76px;
      }
      .title {
        font-size: 36px;
        color: #7D7D7D;
        &.active {
          color: @primary-color-1;
        }
      }
    }
  }
</style>